import { render, staticRenderFns } from "./OperationContact.vue?vue&type=template&id=6beb01ee&"
import script from "./OperationContact.vue?vue&type=script&lang=js&"
export * from "./OperationContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTd,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTd,QBtn,QPagination,QDialog,QCard,QCardSection,QCardActions,QInnerLoading})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
